import GraphemeSplitter from 'grapheme-splitter';

import { type EmojiId } from '../common';

const graphemeSplitter = new GraphemeSplitter();

export function yatSplitter(yat?: EmojiId): string[] | undefined {
    return yat?.length ? graphemeSplitter.splitGraphemes(yat) : undefined;
}
